"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../shared/header-footer.css");
function view(props) {
    return {
        state: {},
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        unmount: function () {
        },
        events: {
            onDropdownSelect: props.onDropdownSelect
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// ../player-career-site-header-footer/controls/PageTemplate/View.js
// module id = 586
// module chunks = 0